import { useEffect, useState } from 'react';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import BotonPagoCulqi from '@/components/reusable/CulqiCheckout/CulqiCheckout';
import Label from '@/components/form/Label/Label';

const downloadInvoicePdf = (href) => {
  if (!href) return;
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', 'comprobante.pdf');
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const ConfirmacionCitaModal = ({ open, onClose, loadingSaveHistory, jsonToPay }) => {
  const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);
  const [invoicePdfUrl, setInvoicePdfUrl] = useState(null);

  useEffect(() => {
    if (!open) return;
    setIsPaymentSuccess(false);
    setInvoicePdfUrl(null);
  }, [open]);

  if (!open) return null;
  const paciente = JSON.parse(localStorage.getItem('user')) || {};
  const emailPaciente = paciente.email ?? 'correo@ejemplo.com';

  return (
    <FlexContainer
      className={'pos-fixed justify-center align-items-center'}
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
      }}
    >
      {loadingSaveHistory && (
        <>
          {' '}
          <>
            <div
              style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'rgba(255,255,255,0.7)',
                zIndex: 10,
                borderRadius: '10px',
              }}
            >
              <div className="spinner" />
            </div>
          </>
        </>
      )}
      {!loadingSaveHistory && (
        <FlexContainer
          className={'pos-rel flex-column align-center width-600px padtb36 padlr36 padt60'}
          style={{
            background: '#ffffff',
            borderRadius: '6px 6px 6px 6px',
            boxShadow: '0px 5px 18px rgba(0,0,0,0.18)',
          }}
        >
          <FlexContainer
            onClick={onClose}
            className={
              'pos-abs top20 right20 pointer width-34px height-34px align-items-center justify-center text-18 fontWhite'
            }
            style={{
              borderRadius: '50%',
              background: '#023B7A',
              fontWeight: '900',
              boxShadow: '0px 2px 5px rgba(2, 59, 122, 0.3)',
            }}
          >
            <ModalCloseIcon />
          </FlexContainer>

          <div
            className={
              'width-520px bgWhite borderrad20 padtb20 padlr12 pos-rel top16 margb20 left30'
            }
            style={{ minHeight: '420px' }}
          >
            {' '}
            <Label className={'text-18 font-bold text-center'} style={{ color: '#023B7A' }}>
              <strong>
                {isPaymentSuccess
                  ? 'Su pago fué realizado correctamente'
                  : 'Para confirmar su reserva, por favor realice el pago'}
              </strong>
            </Label>
            {isPaymentSuccess && (
              <>
                <FlexContainer
                  className={
                    'justify-center align-center margl160 margt28 pos-rel width-180px height-180px'
                  }
                  style={{
                    borderRadius: '50%',
                    border: '4px solid #023B7A',
                  }}
                >
                  <FlexContainer
                    className={
                      'justify-center align-center flex-column margt14 width-140px height-140px '
                    }
                    style={{
                      borderRadius: '50%',
                      background: '#6f8ec0',
                      padding: '5px',
                    }}
                  >
                    <Label
                      className={'text-20 font-semibold text-center'}
                      style={{ color: '#023B7A' }}
                    >
                      <strong>¡Gracias!</strong>
                    </Label>

                    <Label
                      className={'text-14 text-center margt6'}
                      style={{
                        color: '#023B7A',
                        lineHeight: '1.4',
                        fontWeight: 600,
                      }}
                    >
                      Tu cita está
                      <br />
                      pagada <br />y agendada.
                    </Label>
                  </FlexContainer>

                  <FlexContainer
                    className={
                      'justify-center align-center width-40px height-40px right0 bottom4 pos-abs'
                    }
                    style={{
                      borderRadius: '50%',
                      background: '#023B7A',
                      border: '4px solid #ffff',
                    }}
                  >
                    <span
                      className={'text-24 fontWhite margt8'}
                      style={{ fontWeight: 900, lineHeight: 1 }}
                    >
                      <strong>✓</strong>
                    </span>
                  </FlexContainer>
                </FlexContainer>

                {invoicePdfUrl ? (
                  <FlexContainer className={'justify-center margt20'}>
                    <button
                      type="button"
                      onClick={() => downloadInvoicePdf(invoicePdfUrl)}
                      className="height-40 borderrad8 pointer pad10"
                      style={{
                        background: '#023B7A',
                        color: '#ffffff',
                        fontWeight: 700,
                        border: 'none',
                      }}
                    >
                      Descargar comprobante (PDF)
                    </button>
                  </FlexContainer>
                ) : null}
              </>
            )}
            {!isPaymentSuccess && (
              <FlexContainer className={'justify-center gap-22 margt32'}>
                <BotonPagoCulqi
                  email={emailPaciente}
                  jsonToPay={jsonToPay}
                  setIsPaymentSuccess={setIsPaymentSuccess}
                  onElectronicInvoicePdfUrl={setInvoicePdfUrl}
                />
              </FlexContainer>
            )}
          </div>
        </FlexContainer>
      )}
    </FlexContainer>
  );
};

export default ConfirmacionCitaModal;
